import { render, staticRenderFns } from "./ExportationFrameRunningComparison.vue?vue&type=template&id=2bf453a9&scoped=true&"
import script from "./ExportationFrameRunningComparison.vue?vue&type=script&lang=js&"
export * from "./ExportationFrameRunningComparison.vue?vue&type=script&lang=js&"
import style0 from "./ExportationFrameRunningComparison.vue?vue&type=style&index=0&id=2bf453a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf453a9",
  null
  
)

export default component.exports